export default __webpack_public_path__ + "static/media/04__o_1.6540006f.jpg";